import React, { useState } from 'react'
import { Button, ButtonKinds, IconMailDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { LAST_LOGIN_REMINDER_NAMESPACE } from '../i18n'
import { WithLastLoginBadge } from './LastLoginBadge'

interface LoginWithEmailToggleProps {
  isLastLoginMethod: boolean
  onExpand?: () => void
  children: React.ReactNode
}

export const LoginWithEmailToggle: React.FC<LoginWithEmailToggleProps> = ({
  isLastLoginMethod,
  onExpand,
  children,
}) => {
  const { t } = useTranslation(LAST_LOGIN_REMINDER_NAMESPACE)
  const [isExpanded, setIsExpanded] = useState(false)

  const handleExpand = () => {
    if (!isExpanded) {
      setIsExpanded(true)
      onExpand?.()
    }
  }

  return (
    <div>
      {!isExpanded && (
        <div className='mc-mb-4'>
          <WithLastLoginBadge isLastLoginMethod={isLastLoginMethod}>
            <Button
              kind={ButtonKinds.TERTIARY}
              onClick={handleExpand}
              fullWidth
              data-testid='login-with-email-toggle'
            >
              <IconMailDefault className='mc-mr-2' />
              {t('loginWithEmail')}
            </Button>
          </WithLastLoginBadge>
        </div>
      )}

      {isExpanded && <div data-testid='email-form-section'>{children}</div>}
    </div>
  )
}
